module.exports = "<p-growl [value]=\"msgs\"></p-growl>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/notifications/notifications.component.html
// module id = ./src/app/common/notifications/notifications.component.html
// module chunks = main